import React, { Component } from 'react';
import { QrHeader } from '../../organisms';
import { withLanguageContext } from '../../../utils/LanguageContext';

import './styles.css';

/**
 * The landing page floating header.
 *
 * @typedef {Object} Props
 * @prop {boolean} opaque
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
class QrHeaderView extends Component {

	state = {
		navItems: this.genNavItems(this.props.content.qrLandingPage.navigation.items),
	};

	/**
	 * @argument {Object[]} items
	 * @returns {Object[]}
	 */
	genNavItems (items) {
		return items.map(({ href, name, displayAsButton }) => ({
			children: name,
			displayAsButton,
			href,
		}));
	}

	render () {
		return (
			<QrHeader
				className='QrHeaderView'
				navItems={this.state.navItems}
				opaque={this.props.opaque}
			/>
		);
	}

}

export default withLanguageContext(QrHeaderView);



// WEBPACK FOOTER //
// ./src/components/views/QrHeaderView/QrHeaderView.js